import apiFetch from '../apiFetch'

export default function (token, campaignDetailsCountry) {
  return apiFetch({ endPoint: 'CampaignDetails/CampaignDetailsCountry', method: 'POST', token: token, body: campaignDetailsCountry })
}
